import React from "react";
import { fmtInt, type Origen, type OrigenCounts } from "./sandbox/resumenData";
import type { SandboxTheme } from "./sandbox/SandboxResumen";

const OPCIONES: [Origen, string][] = [
  ["all", "Todo"],
  ["organic", "Orgánico"],
  ["paid", "Anuncios"],
];

const SOLO: Record<Exclude<Origen, "all">, string> = { organic: "orgánicos", paid: "anuncios" };

interface Props {
  theme: SandboxTheme;
  origen: Origen;
  counts: OrigenCounts;
  onChange: (origen: Origen) => void;
  disabled?: boolean;
}

/** Selector de origen de escritorio: tres botones con su conteo y un cintillo que dice qué parte del período se ve. */
export function SocialOrigenSelector({ theme, origen, counts, onChange, disabled = false }: Props) {
  return (
    <div className="sbx sbx-origen" data-theme={theme}>
      <div className="row">
        <div className="seg" role="radiogroup" aria-label="Origen de los comentarios" aria-disabled={disabled || undefined}>
          {OPCIONES.map(([id, label]) => (
            <button
              key={id}
              type="button"
              role="radio"
              aria-checked={origen === id}
              disabled={disabled}
              className={id === "paid" ? "is-paid" : undefined}
              data-testid={`origen-${id}`}
              data-count={counts[id]}
              onClick={() => onChange(id)}
            >
              {label} <b>{fmtInt(counts[id])}</b>
            </button>
          ))}
        </div>
        {disabled && <span className="hint">Los mensajes directos no se separan por origen</span>}
        {!disabled && origen !== "all" && (
          <p className="cintillo" data-testid="origen-cintillo">
            Viendo solo {SOLO[origen]}: {fmtInt(counts[origen])} de {fmtInt(counts.all)} comentarios del período
            <button type="button" className="sbx-link" onClick={() => onChange("all")}>
              Ver todo
            </button>
          </p>
        )}
      </div>
    </div>
  );
}
